// @flow
import React, { PureComponent } from 'react';
import DidItSuggestionRep from 'app/common/react/components/do/aggregated-pins/did-it/DidItProfileFeed/DidItSuggestionRep';
import i18n from 'app/common/lib/i18n';
import withResource from 'app/common/lib/react/withResource';
import { compose } from 'redux';
import { Box, Container, Spinner, Text } from 'gestalt';

const NUMBER_RECENT_PINS = 5;

type Props = {
  pins: {
    isLoaded: boolean,
    isFetching: boolean,
    data: Array<Object>,
  },
  loggedInUser: { id: string, username: string },
  resourceLoaded: boolean,
};

export class DidItEmptyProfileTab extends PureComponent<Props> {
  getFilteredPins = () => {
    const { pins } = this.props;
    const filteredPins = pins.isLoaded
      ? // $FlowFixMe: new errors found from flow 0.96 upgrade
        pins.data.filter((pin) => pin.is_whitelisted_for_tried_it)
      : [];
    return filteredPins;
  };

  renderEmptyState = () => {
    const { loggedInUser } = this.props;

    // staging new string, TODO(Dana): replace string below
    i18n._(
      'Tried any of these? Add a photo:',
      'Text suggesting users to Try a Pin they alread saved',
    );
    // take 5 most recent pins
    const recentPins = this.getFilteredPins().slice(0, NUMBER_RECENT_PINS);
    return (
      <Container>
        <Box xs={{ display: 'flexColumn' }} alignItems="center" deprecatedPadding={{ y: 6 }}>
          <Text align="center" lgSize="md" mdSize="sm" smSize="xs" weight="bold">
            {' '}
            {i18n._('Pins you try live here')}{' '}
          </Text>
          <Box xs={{ column: 12 }} md={{ column: 6 }}>
            <Text align="center" color="gray" lgSize="md" mdSize="sm" smSize="xs" weight="bold">
              {i18n._(
                'Add notes and photos to recipes you made, places you traveled and other ideas you tried',
              )}
            </Text>
          </Box>
        </Box>
        {!!recentPins.length && (
          <Box xs={{ column: 12, display: 'flex' }} deprecatedPadding={{ y: 6 }}>
            <Box xs={{ display: false }} md={{ column: 1, display: 'flex' }} />
            <Box xs={{ column: 12 }} md={{ column: 10 }}>
              <Box deprecatedPadding={{ y: 2 }} margin={1}>
                <Text lgSize="lg" mdSize="md" size="lg" smSize="sm" weight="bold">
                  {i18n._(
                    'Tried any of these? Add a photo or note:',
                    'Text suggesting users to Try a Pin they alread saved',
                  )}
                </Text>
              </Box>
              {recentPins.map((pin, idx) => (
                <DidItSuggestionRep key={pin.id} pin={pin} loggedInUser={loggedInUser} />
              ))}
            </Box>
          </Box>
        )}
      </Container>
    );
  };

  render() {
    const { pins } = this.props;

    return (
      <Box>
        <Spinner show={!pins.isLoaded} accessibilityLabel={i18n._('Pins to try are loading')} />
        {pins.isLoaded && this.renderEmptyState()}
      </Box>
    );
  }
}

export default compose(
  withResource({
    name: 'UserPinsResource',
    options: (props) => ({
      prepend: false,
      username: props.loggedInUser.username,
      field_set_key: 'did_it_grid_item',
      page_size: 10,
    }),
    key: 'pins',
  }),
)(DidItEmptyProfileTab);
